module.exports = __webpack_public_path__ + "assets/7104f9198127dfc5d93f54398b851d2f.png";